import { ArrowUpRight } from "lucide-react";
import { MaskLine, Reveal } from "./Reveal";
import { SERVICES } from "../../lib/data";
import { scrollToId } from "../../lib/scroll";

export const Tjenester = () => {
  const go = () => scrollToId("#kontakt");

  return (
    <section id="tjenester" className="bg-paper py-24 sm:py-32" data-testid="tjenester-section">
      <div className="max-w-[1600px] mx-auto px-5 sm:px-8">
        <div className="mb-16 sm:mb-24 max-w-3xl">
          <Reveal>
            <span className="font-oswald uppercase text-xs tracking-[0.3em] text-redx">Hva vi leverer</span>
          </Reveal>
          <h2 className="font-oswald font-bold uppercase tracking-tight leading-[0.9] text-5xl sm:text-7xl mt-4 text-ink">
            <MaskLine>Fem fagfelt.</MaskLine>
            <MaskLine delay={0.1}>Én leverandør.</MaskLine>
          </h2>
        </div>

        <div className="border-t border-ink/15">
          {SERVICES.map((s, i) => (
            <div
              key={s.num}
              className="group grid grid-cols-12 gap-6 items-center py-10 sm:py-14 border-b border-ink/15"
              data-testid={`service-row-${s.num}`}
            >
              {/* Number */}
              <div className="col-span-3 sm:col-span-2">
                <span className="font-oswald text-3xl sm:text-6xl text-ink/25 group-hover:text-redx transition-colors duration-300">
                  {s.num}
                </span>
              </div>

              {/* Title + text */}
              <div className={`col-span-9 sm:col-span-4 ${i % 2 === 1 ? "sm:order-3" : ""}`}>
                <h3 className="font-oswald uppercase text-3xl sm:text-5xl tracking-tight text-ink leading-none">
                  {s.title}
                </h3>
                <p className="text-ink/60 mt-4 leading-relaxed max-w-sm">{s.text}</p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {s.points.map((p) => (
                    <span key={p} className="text-xs font-oswald uppercase tracking-widest border border-ink/20 px-3 py-1 text-ink/70">
                      {p}
                    </span>
                  ))}
                </div>
              </div>

              {/* Image */}
              <div className={`col-span-12 sm:col-span-6 ${i % 2 === 1 ? "sm:order-2" : ""}`}>
                <div className="relative h-56 sm:h-72 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 scale-105 group-hover:scale-110 transition-all duration-700 ease-out"
                  />
                  <button
                    onClick={go}
                    data-testid={`service-cta-${s.num}`}
                    className="absolute bottom-4 right-4 bg-white text-ink p-3 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 hover:bg-redx hover:text-white"
                    aria-label={`Forespør ${s.title}`}
                  >
                    <ArrowUpRight size={20} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
